export default __webpack_public_path__ + "static/media/farm.f95abab1.mp3";